import api from './api';

// Contact interfaces
export interface ContactInfo {
  id: number;
  whatsApp_Number: string;
  facebook_Page: string;
  youTube_Channel: string;
  tiktokChannel: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
  data: ContactInfo[];
}

let getAllPromise: Promise<ContactResponse> | null = null;

// Contact service functions
export const contactService = {
  // Get all contact information (deduplicated: concurrent callers share the same request)
  getAll: async (): Promise<ContactResponse> => {
    if (getAllPromise) return getAllPromise;
    getAllPromise = (async () => {
      try {
        const response = await api.get<ContactResponse>('/api/Contact/getAll');
        return response.data;
      } catch (error: any) {
        // Silently handle 404 - endpoint may not exist on all deployments
        if (error.response?.status !== 404) {
          console.warn('Contact information unavailable:', error.message);
        }
        throw error;
      } finally {
        getAllPromise = null;
      }
    })();
    return getAllPromise;
  },

  // Get WhatsApp number specifically
  getWhatsAppNumber: async (): Promise<string | null> => {
    try {
      const response = await contactService.getAll();
      if (response.success && response.data.length > 0) {
        return response.data[0].whatsApp_Number || null;
      }
      return null;
    } catch (error) {
      // Silently return null - error already logged in getAll
      return null;
    }
  },

  // Get all social media links
  getSocialLinks: async (): Promise<ContactInfo | null> => {
    try {
      const response = await contactService.getAll();
      if (response.success && response.data.length > 0) {
        return response.data[0];
      }
      return null;
    } catch (error) {
      // Silently return null - error already logged in getAll
      return null;
    }
  },

  clearGetAllPromise: (): void => {
    getAllPromise = null;
  }
};

export default contactService; 